var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilverPlanet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    viewBox: "0 0 480 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_862_36218)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_862_36218)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    rx: 240,
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_862_36218)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.586,
    cy: 164.286,
    rx: 263.415,
    ry: 258.571,
    fill: "#CDCDCD"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_862_36218)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 181.463,
    cy: 128.571,
    rx: 160.976,
    ry: 157.143,
    fill: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_f_862_36218)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.1861,
    cy: 40.7998,
    rx: 68.1861,
    ry: 40.7998,
    transform: "matrix(0.981993 -0.188915 0.196258 0.980552 219.512 411.477)",
    fill: "#DFDFDF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_862_36218",
    x: 0,
    y: 0,
    width: 480,
    height: 480,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12.7072,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_862_36218"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 47.652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.800065 0 0 0 0 0.800065 0 0 0 0 0.800065 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_862_36218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_862_36218",
    x: -237.437,
    y: -284.893,
    width: 908.045,
    height: 898.359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 95.3039,
    result: "effect1_foregroundBlur_862_36218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_862_36218",
    x: -138.352,
    y: -187.411,
    width: 639.631,
    height: 631.965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 79.4199,
    result: "effect1_foregroundBlur_862_36218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_862_36218",
    x: 131.732,
    y: 301.257,
    width: 325.492,
    height: 274.689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 47.652,
    result: "effect1_foregroundBlur_862_36218"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_862_36218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 480,
    rx: 240,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverPlanet);
export default __webpack_public_path__ + "static/media/SilverPlanet.765aa471d8c275f8695df744f928015c.svg";
export { ForwardRef as ReactComponent };